module.exports = __webpack_public_path__ + "img/s.5d33a875.jpg";